$(function () {
    var lastScrollTop = 0;
    $(window).on('scroll resize', function () {
        var scrollTop = ($(window).scrollTop() <= 0 ? 0 : $(window).scrollTop());
        var heightHead = $("#sgkSuperNav").outerHeight();
        var heightMenuMain = $("#sgkMainNav").outerHeight();
        var heightMenuMobile = $("#sgkMobileNav").outerHeight();
        var heightMenu = heightMenuMain > 0 ? heightMenuMain : heightMenuMobile;

        if (!$('#d-lg').is(':visible') && !$('#d-xl').is(':visible') && $('#menu').hasClass('sgkMenuClose')) {
            $('body').css("padding-top", heightHead);
            $('.sgktableofcontent').css("top", (heightHead + 10));
            if (scrollTop <= heightHead) {
                $('#sgkHeader').addClass('scrolledWait').removeClass('scrolledDown').removeClass('scrolledUp');
            } else if (scrollTop <= lastScrollTop) {
                $('#sgkHeader').removeClass('scrolledDown').addClass('scrolledUp');
            } else {
                $('#sgkHeader').removeClass('scrolledUp').addClass('scrolledDown');
            }
        } else {
            if (scrollTop > heightHead) {
                sgkMenu.autoHide();
                $('body').addClass('scroll-top').css("padding-top", heightMenu);
                $('.sgktableofcontent').css("top", heightMenu);
            } else {
                sgkMenu.autoShow();
                $('body').removeClass('scroll-top').css("padding-top", 0);
            }
        }

        lastScrollTop = scrollTop;
    }).trigger('scroll');
})
